<template>
    <div>
        <div style="display: grid; grid-template-columns: 2fr 3fr; grid-gap: 15px; align-items: start;">
            <div>
                <DCard
                    v-for="(commandCategory, category) in commandCategories"
                    :key="category"
                    style="margin-right: 20px; margin-bottom: 10px;"
                    class="category"
                >
                    <h2 class="category__title h3">
                        {{ category }}
                    </h2>
                    <DCard
                        v-for="command in commandCategory"
                        :key="command.name"
                        style="margin-right: 20px; margin-bottom: 10px;"
                        class="category__item"
                        :class="consoleCommand.name === command.name ? 'bg-primary text-white': 'bg-white text-black'"
                    >
                        <DCardBody
                            :id="`cli-${slugify(command.name)}`"
                            style="cursor: pointer;"
                            @click="showProperties(command)"
                        >
                            <div>
                                <span class="font-lg">{{ command.name }}</span>
                                <div class="font-xs text-muted">
                                    {{ command.description }}
                                </div>
                            </div>
                        </DCardBody>
                    </DCard>
                </DCard>
            </div>
            <div style="position: sticky; top: 0;">
                <DCard>
                    <h2 class="category__title h3">
                        {{ __('tools.testing.cli_commands.options') }}
                    </h2>
                    <DForm
                        style="padding: 15px"
                        @submit.prevent="executeCommand"
                    >
                        <DFormRow
                            v-for="option in options"
                            v-show="option.hidden === false"
                            :key="option.name"
                            :label="option.name"
                            :hint="option.description"
                        >
                            <DSwitch
                                v-if="option.type === 'boolean'"
                                :id="`command-option-${option.name}`"
                                v-model="option.value"
                                color="success"
                                variant="3d"
                            />
                            <DInput
                                v-else-if="option.type === 'text'"
                                :id="`command-option-${option.name}`"
                                v-model="option.value"
                            />
                            <DInput
                                v-else-if="option.type === 'date'"
                                :id="`command-option-${option.name}`"
                                v-model="option.value"
                                type="date"
                            />
                        </DFormRow>
                        <DFormRow
                            v-if="consoleCommand"
                            label=""
                        >
                            <DButton
                                id="btn-save"
                                label="Execute"
                                :disabled="isInLoadingState"
                                @click="executeCommand"
                            />
                        </DFormRow>
                    </DForm>
                </DCard>
            </div>
            <DModal
                v-model:show="modalVisible"
                title="Console output"
                is-big
                @close="modalVisible = false"
            >
                <div class="text-sm">
                    <pre>{{ output }}</pre>
                </div>
            </DModal>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CLICommands',
    props: {
        commandCategories: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            consoleCommand: '',
            options: [],
            output: null,
            modalVisible: false
        }
    },
    methods: {
        showProperties (command) {
            this.consoleCommand = command
            this.options = command.options
        },

        executeCommand () {
            window.window.axios.get(this.$route('tools.cli_commands.execute', { command: this.consoleCommand.command, options: this.options }))
                .then(res => {
                    this.output = res.data
                    this.modalVisible = true
                }).catch(err => {
                    this.output = err.message()
                    this.modalVisible = true
                })
        },

        slugify (value) {
            return value
                .toLowerCase()
                .replace(/ /g, '-')
                .replace(/-+/g, '-')
                .replace(/[^\w-]+/g, '')
        }
    }
}
</script>

<style scoped lang="scss">
.category {
    margin-bottom: 30px !important;
}

main {
    .category__title {
        padding: 0.5rem 1.25rem !important;
        text-transform: capitalize;
        margin-bottom: 0;
        border-bottom: 1px solid var(--colorAppBorder);
    }

    .category__item {
        border: 0 !important;
        border-bottom: 1px solid var(--colorAppBorder) !important;
        margin-bottom: 0 !important;

        .card-body {
            padding: 1.25rem !important;
        }
    }

    .category__item:last-of-type {
        border-bottom: 0 !important;
    }
}
</style>
